/* BMP swatch warm + instant swap (SW-1, SW-3) - 13 Oct 2026. Additive; server refresh remains source of truth. */
(() => {
  if (window.__bmpSwatchWarm) return; window.__bmpSwatchWarm = true;
  const warmed = new Map();
  const box = () => document.querySelector('[data-bmp-swatch-warm]');
  const norm = (s) => (s || '').trim().toLowerCase();
  function tpl(color) {
    const b = box(); if (!b) return null;
    for (const t of b.querySelectorAll('template[data-color]')) if (norm(t.dataset.color) === norm(color)) return t.content.querySelector('img');
    return null;
  }
  function colorInput(el) {
    const input = el && el.closest && (el.closest('variant-picker label')?.querySelector('input') || el.closest('variant-picker input'));
    if (!input || input.closest('product-card, quick-add-dialog')) return null;
    return tpl(input.value) ? input : null;
  }
  function mainImg() {
    const g = document.querySelector('media-gallery'); if (!g) return null;
    const imgs = [...g.querySelectorAll('img.product-media__image')].filter((i) => !i.closest('dialog, [data-bmp-swatch-warm], .dialog-zoomed-gallery'));
    return imgs.find((i) => { const r = i.getBoundingClientRect(); return r.width > 100 && r.bottom > 0 && r.top < innerHeight && r.left > -10 && r.left < innerWidth - 50; }) || imgs[0] || null;
  }
  function sizesFor(t) { const m = mainImg(); return (m && m.getAttribute('sizes')) || t.getAttribute('sizes') || '100vw'; }
  function warm(color) {
    const key = norm(color); if (warmed.has(key)) return warmed.get(key);
    const t = tpl(color); if (!t) return null;
    const im = new Image(); im.decoding = 'async'; im.sizes = sizesFor(t); im.srcset = t.getAttribute('srcset') || ''; im.src = t.getAttribute('src');
    const p = (im.decode ? im.decode() : new Promise((r, j) => { im.onload = r; im.onerror = j; })).then(() => im, () => null);
    warmed.set(key, p); return p;
  }
  // SW-1: warm on intent
  const onIntent = (e) => { const i = colorInput(e.target); if (i) warm(i.value); };
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  // SW-1: warm the other colours when idle (skipped on Save-Data / 2G)
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  function idleWarm() {
    const c = navigator.connection; if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
    const b = box(); if (!b) return;
    const colors = [...b.querySelectorAll('template[data-color]')].map((t) => t.dataset.color);
    (async () => { for (const col of colors) { await warm(col); await new Promise((r) => idle(r, { timeout: 2000 })); } })();
  }
  if (document.readyState === 'complete') idle(idleWarm, { timeout: 4000 }); else addEventListener('load', () => idle(idleWarm, { timeout: 4000 }), { once: true });
  // SW-3: instant swap on click; only once the image is decoded (no blank frame), only if still selected
  let seq = 0;
  document.addEventListener('change', (e) => {
    const input = colorInput(e.target); if (!input || !input.checked) return;
    const my = ++seq; const t = tpl(input.value); const p = warm(input.value); if (!t || !p) return;
    p.then((ok) => {
      if (!ok || my !== seq || !input.checked) return;
      const img = mainImg(); if (!img) return;
      const want = (t.getAttribute('src') || '').split('?')[0];
      if ((img.currentSrc || img.src).split('?')[0].replace(/^https?:/, '') === want.replace(/^https?:/, '')) return; // server already swapped
      img.removeAttribute('loading');
      img.srcset = t.getAttribute('srcset') || ''; img.src = t.getAttribute('src'); if (t.alt) img.alt = t.alt;
      img.dataset.bmpSwapped = '1';
    });
  }, true);
})();
